<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <form id="reportCreateForm" name="reportCreateForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
      <div class="row mt-0" v-if="id <= 0">
        <div class="col custom-form-main-label">
          {{$t('add_report')}}
        </div>
      </div>
      <div class="row mt-0" v-if="id > 0">
        <div class="col custom-form-main-label">
          {{$t('manage_report')}}
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <filter-container @change="filterChanged" v-bind:user="user" ref="filterContainer"></filter-container>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 p-0 custom-form-label">
          {{$t('name')}}
        </div>
      </div>
      <div class="form-group row mt-1">
        <div class="col-12 px-0">
          <input required v-model="name" type="text" id="txtreportname" v-bind:placeholder="$t('name')" maxlength="200" name="name" class="form-control" />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 p-0 custom-form-label">
          {{$t('show_in_admin')}}
        </div>
      </div>
      <div class="form-group row mt-1">
        <div class="col-12 px-0">
          <div class="custom-control custom-checkbox custom-control-inline">
            <input class="custom-control-input chk-task-success" name="check_admin" id="check_admin" type="checkbox" v-model="enabledforadmin" v-bind:checked="enabledforadmin == true" />
            <label class="custom-control-label chk-task-success" for="check_admin">
              {{$t('enabled')}}
            </label>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 p-0 custom-form-label">
          {{$t('hide_dataset_in_email')}}
        </div>
      </div>
      <div class="form-group row mt-1">
        <div class="col-12 px-0">
          <div class="custom-control custom-checkbox custom-control-inline">
            <input class="custom-control-input chk-task-success" name="check_dataset_in_email" id="check_dataset_in_email" type="checkbox" v-model="nodatasetinemail" v-bind:checked="nodatasetinemail == true" />
            <label class="custom-control-label chk-task-success" for="check_dataset_in_email">
              {{$t('enabled')}}
            </label>
          </div>
        </div>
      </div>


      <div class="row mt-3">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('sorting_column')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col px-0">
          <select v-model="selectedsortingcol" class="form-control schedulerselect" v-bind:id="'select_sorting_column_' +  getId()" v-on:change="onTypeChange" v-select>
            <option value="">{{$t('select')}}</option>
            <option value="user">{{$t('user')}}</option>
            <option value="name">{{$t('name')}}</option>
            <option value="location">{{$t('location')}}</option>
            <option value="status">{{$t('status')}}</option>
            <option value="datescheduled">{{$t('datescheduled')}}</option>
            <option value="priority">{{$t('priority')}}</option>
            <option value="shift">{{$t('shift')}}</option>
            <option value="createdby">{{$t('createdby')}}</option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('assigntospecific')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col px-0">
          <select v-model="selectedtype" class="form-control schedulerselect" v-bind:id="'select_assigned_type_' +  getId()" v-on:change="onTypeChange" v-select>
            <option value="">{{$t('select')}}</option>
            <option value="user">{{$t('user')}}</option>
            <option value="team">{{$store.translate('team')}}</option>
            <option value="email">{{$t('email')}}</option>
          </select>
        </div>
      </div>
      <div class="row mt-1" v-show="selectedtype === 'user'">
        <div class="col px-0">
          <user-selector required="false" ref="userSelectorRef" loadDataOnInit="false" @event-change-member="onChangeMember"></user-selector>
        </div>
      </div>
      <div class="row mt-1" v-show="(selectedtype === 'team')">
        <div class="col px-0">
          <team-select-selector loadDataOnInit="false" style="width:100%" ref="teamSelectorRef" @event-change-team="onChangeTeam"></team-select-selector>
        </div>
      </div>
      <!--<div class="row mt-3">
        <div class="col-12 p-0 custom-form-label">
          {{$t('email')}}
        </div>
      </div>-->
      <div class="form-group row mt-1" v-show="selectedtype === 'email'">
        <div class="col-12 px-0">
          <input :required="requiredEmail==true" v-model="email" type="text" id="txtreportemail" v-bind:placeholder="$t('email')" maxlength="500" name="email" class="form-control" />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <create-schedule showAddedToTeamOption="false" showOnProcedureDoneOption="false"
                           showEndDateOption="false" showWeekRepeatOption="false"
                           showNewUserOption="false" ref="createScheduleControl"></create-schedule>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-12 p-0 custom-form-label">
          {{$t('statistics')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col px-0">
          <statistics-editor ref="statisticsEditor"></statistics-editor>
        </div>
      </div>

      <div class="row px-0 mt-1">
        <div class="text-right col-sm-12 mt-1 px-0 text-right">
          <a v-if="id > 0" v-bind:href="$store.getTodoUrl() + '?reportid=' + id" target="_blank" class="btn btn-link mt-1" style="color:inherit">{{$t('view')}}</a>
          <button type="submit" class="btn btn-light mt-1 ml-1" @click="viewSchedule">{{$t('run')}}</button>
          <button type="submit" class="btn skin primary-button mt-1 ml-1" @click="saveSchedule">{{$t('save')}}</button>
        </div>
      </div>
    </form>


    <div class="row m-0 p-0 mt-3" v-if="id > 0">
      <div class="col p-0 m-0">
        <table class="table">
          <tr><td class="custom-form-label" style="padding-left:0px !important;">{{$store.translate('subreports')}} </td><td align="right">{{subreports.length}}</td></tr>
          <tr v-for="option in subreports" class="mt-1">
            <td align="left" style="padding-left:0px !important;">{{ option.ReportName }}</td>
            <td align="right"><a @click="deleteSubReport(option.Id)"><i class="icon-trash"></i></a></td>
          </tr>
        </table>
      </div>

    </div>
    <div class="row mt-3" v-if="id > 0">
      <div class="container-fluid">
        <div class="col-12 p-0 m-0">
          <select class="form-control" v-bind:id="'select_report_' +  getId()" v-select>
            <option value="" style="">{{$t('select_report')}}</option>
            <option v-for="report in reports" v-bind:value="report.Id">
              {{ report.ReportName }}
            </option>
          </select>
        </div>
        <div class="text-right col-12 p-0 m-0 mt-1 text-right">
          <button type="submit" @click="addSubReport" class="btn skin btn-primary mt-1">{{$t('save')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CreateSchedule from '../Scheduling/create-schedule.vue'
  import FilterContainer from '../filter/filter-container.vue'

  var selectedtype = '';
  var selectedsortingcol = '';
  var id = 0;
  var reports = [];
  var subreports = [];
  export default {
    name: "add-report-schedule",
    components: {
      CreateSchedule,
      FilterContainer,
    },
    props: {
      user: {
        type: String,
        default: ''
      },
      requiredEmail: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        selectedtype: '',
        selectedsortingcol: '',
        name: '',
        email: '',
        id: 0,
        memberId: '',
        teamId: -1,
        enabledforadmin: false,
        nodatasetinemail: false,
        reports: [],
        subreports: [],
      };
    },
    methods: {
      async deleteSubReport(id) {
        try {
          this.$http.delete(`/api/Reports/v1/SubReport/${id}`).then(async response => {
            this.loadSubReports(this.id);
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      loadSubReports(reportid) {
        try {
          this.subreports = [];
          var url = `/api/Reports/v1/SubReports/${reportid}`;
          this.$http.get(url).then(async response => {
            this.subreports = response.data;
            Vue.set(this, "subreports", this.subreports);
            this.$forceUpdate();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      async addSubReport() {
        var childid = $('#select_report_' + this.getId()).val();
        var request = { parentreportid: this.id, childreportid: childid };
        try {
          var response = await this.$http.post(
            '/api/Reports/v1/SubReports',
            request
          ).then(async response => {
            this.loadSubReports(this.id);
          });

        } catch (err) {
          alert(err);
        }
      },
      loadReports(reportid) {
        try {
          this.reports = [];
          var url = `/api/Reports/v1/Site/SubReport/${reportid}`;
          this.$http.get(url).then(async response => {
            this.reports = response.data;
            //console.log(this.users);
            if (this.reports !== null && this.reports.length > 0) {
              this.reports = this.reports.sort(function (a, b) {
                var x = a.ReportName.toLowerCase();
                var y = b.ReportName.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            $('#select_report_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      filterChanged() {
        var filterItems = this.$refs.filterContainer.getCurrentFilter();
        for (var i = 0; i < filterItems.length; i++) {
          if (filterItems[i].type == "procedure") {
            this.$refs.statisticsEditor.setProcedure(parseInt(filterItems[i].config.data));
          }
        }
      },
      getId() {
        return this._uid;
      },
      onChangeTeam(teamid) {
        this.teamId = teamid;
      },
      onChangeMember(memberId) {
        this.memberId = memberId;
      },
      onTypeChange() {
        try {
          switch (this.selectedtype) {
            case 'user':
              this.teamId = -1;
              this.email = '';
              this.requiredEmail = false;
              break;
            case 'team':
              this.memberId = '';
              this.email = '';
              this.requiredEmail = false;
              break;
            case 'email':
              this.memberId = '';
              this.teamId = -1;
              this.requiredEmail = true;
              break;
          }
        }
        catch (err) {
          console.log(err);
          //alert(err);
        }
      },

      clearFields() {
        this.$refs.createScheduleControl.clearFields();
        this.name = '';
        this.$refs.teamSelectorRef.selectTeam("");
        this.$refs.userSelectorRef.selectUser("");
        this.teamId = -1;
        this.email = '';
        this.memberId = '';
        this.requiredEmail = false;
        this.enabledforadmin = false;
        this.nodatasetinemail = false;
      },
      fetchReloadData() {
        try {
          this.$refs.userSelectorRef.fetchReloadData();
          this.$refs.teamSelectorRef.fetchReloadData(null);
        }
        catch (err) {
          //alert(err);
        }
      },
      async viewSchedule() {
        var buttons = this.$refs.filterContainer.getCurrentFilter();
        var filter = [];
        for (var i = 0; i < buttons.length; i++) {

          filter.push({
            type: buttons[i].type, data: buttons[i].config.data, customstyle: buttons[i].config.customstyle,
            abbreviation: buttons[i].config.abbreviation, icon: buttons[i].config.icon, text: buttons[i].config.text,
            customclass: buttons[i].config.customclass,
            menu: buttons[i].config.menu, key: buttons[i].config.key
          })
        }
        const filtersJson = JSON.stringify(filter);
        //this.$refs.projectselector.onFormSubmit();
        if (!$('#reportCreateForm').valid())
          return false;
        var data = this.$refs.createScheduleControl.getSchedule();
        console.log(data);

        this.isTimeValid = true;
        var regExp = new RegExp('^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$');

        if (data.Time !== '') {
          if (regExp.test(data.Time) === false) {
            this.isTimeValid = false;
            alert("Time is not valid.");
          }
        }

        if (!this.isTimeValid) {
          return false;
        }

        //if (data.Time !== '') {
        //  if (data.StartDate === '') {
        //    var date = '1901-01-01' + ' ' + data.Time;
        //    data.Time = get24FormatTime(date);
        //  } else {
        //    var date = data.StartDate + ' ' + data.Time;
        //    var dateAndtime = convertNormalDate(date);
        //    data.StartDate = getDateWithFormat(dateAndtime);
        //    data.Time = get24FormatTime(dateAndtime);
        //  }
        //} else if (data.Time === '' && data.StartDate !== '') {
        //  var date = data.StartDate;
        //  var dateAndtime = convertNormalDate(date);
        //  data.StartDate = getDateWithFormat(dateAndtime);
        //}
        if (data.StartDate !== '') {
          data.StartDate = convertNormalDate(data.StartDate);
        }
        var request = {
          model: data, name: this.name, email: this.email,
          filtersJson: filtersJson, id: this.id,
          todaydate: moment().format('YYYY-MM-DD'),
          enabledforadmin: this.enabledforadmin,
          nodatasetinemail: this.nodatasetinemail,
          sortingcolumn: this.selectedsortingcol,
        };
        console.log(request);
        try {
          var response = await this.$http.post(
            '/api/Reports/v1/View',
            request
          ).then(async response => {
            //this.clearFields();
            //vm.$root.$emit('manage_report_schedule');
          });

        } catch (err) {
          alert(err);
        }
      },
      async saveSchedule() {

        var statisticsData = this.$refs.statisticsEditor.getJsonData();

        var buttons = this.$refs.filterContainer.getCurrentFilter();
        var filter = [];
        for (var i = 0; i < buttons.length; i++) {

          filter.push({
            type: buttons[i].type, data: buttons[i].config.data, customstyle: buttons[i].config.customstyle,
            abbreviation: buttons[i].config.abbreviation, icon: buttons[i].config.icon, text: buttons[i].config.text,
            customclass: buttons[i].config.customclass,
            menu: buttons[i].config.menu, key: buttons[i].config.key
          })
        }
        const filtersJson = JSON.stringify(filter);
        //this.$refs.projectselector.onFormSubmit();
        if (!$('#reportCreateForm').valid())
          return false;
        var data = this.$refs.createScheduleControl.getSchedule();
        console.log(data);

        this.isTimeValid = true;
        var regExp = new RegExp('^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$');

        if (data.Time !== '') {
          if (regExp.test(data.Time) === false) {
            this.isTimeValid = false;
            alert("Time is not valid.");
          }
        }

        if (!this.isTimeValid) {
          return false;
        }

        /*
        if (data.Time !== '') {
          if (data.StartDate === '' && data.StartDate === '') {
            // Do nothing, only time
          } else {
            //var date = data.StartDate + ' ' + data.Time;
            //var dateAndtime = convertNormalDate(date);
            data.StartDate = convertNormalDate(data.StartDate);
            //data.Time = get24FormatTime(dateAndtime);
          }
        } else if (data.Time === '' && data.StartDate !== '') {
          //var date = data.StartDate;
          //var dateAndtime = convertNormalDate(date);
          data.StartDate = convertNormalDate(data.StartDate);
        }
        */

        if (data.StartDate !== '') {
          data.StartDate = convertNormalDate(data.StartDate);
        }

        var settings = { Diagrams: this.$refs.statisticsEditor.getData() };
        var request = {
          model: data, name: this.name, email: this.email, filtersJson: filtersJson, id: this.id,
          schdeduleFor: this.selectedtype, user: this.memberId, teamId: this.teamId,
          settings: settings,
          enabledforadmin: this.enabledforadmin,
          nodatasetinemail: this.nodatasetinemail,
          sortingcolumn: this.selectedsortingcol,
        };
        console.log(request);
        try {
          var response = await this.$http.post(
            '/api/Reports/v1',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('manage_report_schedule');

          });

        } catch (err) {
          alert(err);
        }
      },
      async initFilters(filters) {
        if (filters != null) {
          for (var i = 0; i < filters.length; i++) {
            this.$refs.filterContainer.addButton(filters[i].type, filters[i], false);
          }
        }
      },
      async getReportSchedule(id) {
        try {
          this.clearFields();
          if (id > 0) {
            this.loadReports(id);
            this.loadSubReports(id);
            this.$http.get(`/api/Reports/v1/${id}`).then(async response => {
              var report = response.data;
              this.name = report.ReportName;
              this.enabledforadmin = report.EnabledForAdmin;
              this.nodatasetinemail = report.NoDataSetInEmail;
              const filterJSON = JSON.parse(report.Filters);
              this.initFilters(filterJSON);
              if (report.Settings && report.Settings != null)
                if (report.Settings.Diagrams && report.Settings.Diagrams != null)
                  this.$refs.statisticsEditor.setData(report.Settings.Diagrams);
              /*
              if (report.Time !== '' && report.Time !== null) {
                if (report.date === '') {
                  //var date = '1901-01-01' + ' ' + report.Time;
                  //report.Time = convertToTime(date);
                  report.Time = report.Time;
                } else {
                  report.date = convertShortDateToLocal(report.date);
                  report.Time = report.Time;
                  //var date = report.date + ' ' + report.Time;
                  //report.date = convertToDate(date);
                  //report.Time = convertToTime(date);
                }
              } else if ((report.Time === '' || report.Time === null) && report.date !== '') {
                report.date = convertShortDateToLocal(report.date);
              }
              */

              if (report.date !== '') {
                report.date = convertShortDateToLocal(report.date);
              }

              this.$refs.createScheduleControl.setControls(report.Type, report.date, report.Weekdays, report.Time);
              this.selectedtype = report.ScheduleFor;
              $("#select_assigned_type_" + this.getId()).val(this.selectedtype);
              $("#select_assigned_type_" + this.getId()).trigger('change');

              this.selectedsortingcol = report.SortedColumn;
              $("#select_sorting_column_" + this.getId()).val(this.selectedsortingcol);
              $("#select_sorting_column_" + this.getId()).trigger('change');


              switch (this.selectedtype) {
                case 'user':
                  this.teamId = -1;
                  this.email = '';
                  this.memberId = report.Email;
                  this.$refs.userSelectorRef.selectUser(report.Email);
                  break;
                case 'team':
                  this.memberId = '';
                  this.email = '';
                  if (report.TeamId != null) {
                    this.teamId = report.TeamId;
                    this.$refs.teamSelectorRef.selectTeam(report.TeamId);
                  }
                  break;
                case 'email':
                  this.requiredEmail = true;
                  this.memberId = '';
                  this.teamId = -1;
                  this.email = report.Email;
                  break;
              }
            });
          }
        } catch (err) {
          alert('some error:' + err)
        }
      },
    },
    watch: {
      id: function (newVal, oldVal) {
        this.$refs.filterContainer.clearFilters();
        this.name = '';
        this.email = '';
        if (newVal > 0) {
          this.getReportSchedule(newVal);
        } else {

        }

      },
    },
    mounted() {
      _componentValidation('#reportCreateForm');
      this.$refs.createScheduleControl.showTimeOption = true;

      this.$refs.filterContainer.hideMyFilter = true;
      this.$refs.filterContainer.hideSaveFilter = true;
      this.$refs.filterContainer.hideMySchedule = true;
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/report/add-report-schedule.vue